import PropTypes from 'prop-types';

import { valueType } from '.';

export const ytInsightType = PropTypes.shape({
  ages: PropTypes.arrayOf(valueType),
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
      meta: PropTypes.shape({
        countryName: PropTypes.string,
      }),
    }),
  ),
  genders: PropTypes.arrayOf(valueType),
  locales: PropTypes.arrayOf(valueType),
});
